<template>
    <div class="test-item-wrapper">
        <div>
            <div class="title">{{test.title}}</div>
        </div>
        <div class="actions">
            <div
                v-if="test.session.status === 'in_progress'"
                class="actions__item actions__item--blue"
            >
                <a
                    :href="test.session.redirect_url"
                    target="__blank"
                >Продолжить прохождение</a>
            </div>
        </div>
        
    </div>
</template>

<script>
import dateFormat from '../../../../tools/date_format';
import { mapActions } from 'vuex';

export default {
    name: 'TestInProgressItem',
    props: {
        test: Object,
    },
    computed: {
        date() {
            let t = new Date(this.test.session.end_time);
            const hours = t.getHours().toString().padStart(2, "0");
            const minutes = t.getMinutes().toString().padStart(2, "0");
            return `${dateFormat(t.getTime() / 1000)} в ${hours}:${minutes}`;
        },
        score() {
            return this.test.session.score;
        },
    },
};
</script>

<style scoped lang="scss">
    @import '../../../../styles/rem';

    .test-item-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // height: rem(134);
        width: 49%;
        background-color: #fff;
        padding: rem(24);
        margin-bottom: rem(18);
        box-shadow: 0 rem(6) rem(10) rgba(131, 134, 163, 0.12);
        
        @include on-mobile {
            width: 100%;
            margin: 0 mrem(16);
            // height: mrem(110);
            height: auto;
            padding: mrem(24);
            margin-bottom: mrem(12);
        }

        .title {
            font-family: "Montserrat";
            font-style: normal;
            font-weight: 600;
            font-size: rem(16);
            line-height: rem(24);
            color: #2A2626;
            padding-bottom: rem(16);

            @include on-mobile {
                font-size: mrem(15);
                line-height: mrem(22);
                padding-bottom: mrem(16);
            }
        }

        .date,
        .result {
            font-family: "Montserrat";
            font-style: normal;
            font-weight: normal;
            font-size: rem(14);
            line-height: rem(20);
            color: #2A2626;
            padding-bottom: rem(8);

            @include on-mobile {
                font-size: mrem(14);
                line-height: mrem(20);
                padding-bottom: mrem(8);
            }

            &--bold {
                font-weight: bold;
            }

            &__check {
                color: #EF627D;
            }
        }

        .actions{
            display: flex;
            justify-content: space-between;
            margin-top: rem(12);

            @include on-mobile {
                flex-direction: column;
            }

            &__item {

                a {
                    cursor: pointer;
                    display: inline;
                    font-family: "Montserrat";
                    font-style: normal;
                    font-weight: 500;
                    font-size: rem(14);
                    line-height: rem(17);
                    text-align: center;
                    padding-bottom: rem(4);
                    color: #97A4BA;
                    border-bottom: 1px solid #97A4BA;

                    @include on-mobile {
                        font-size: 14px;
                        line-height: 17px;
                        display: inline;
                    }
                }
                
                &--blue a {
                    color: #4663AB;
                    border-bottom: 1px solid #4663AB;
                }
            }

          
        }
    }
</style>